import 'ress/dist/ress.min.css'
import headerMenu from '../modules/_headerMenu'
import footerAnimation from '../modules/_footerAnimation'
import SmoothScroll from '../modules/_SmoothScroll'

headerMenu()
footerAnimation()

{
  const scroller = new SmoothScroll('[href^="#"]', {
    tolerance: 100
  })
  scroller.init()
}

{
  const wpPagenavi = document.querySelector('.wp-pagenavi');
  if (wpPagenavi) {
    const pageLinks = wpPagenavi.querySelectorAll('.page');

    pageLinks.forEach(link => {
      let pageNumber = parseInt(link.textContent, 10);

      if (pageNumber >= 1 && pageNumber <= 9) {
        link.textContent = `0${pageNumber}`;
      }
    });

    const currentPage = wpPagenavi.querySelector('.current');
    if (currentPage) {
      let currentNumber = parseInt(currentPage.textContent, 10);

      if (currentNumber >= 1 && currentNumber <= 9) {
        currentPage.textContent = `0${currentNumber}`;
      }
    }
  }
}
